/** Persistencia de dismiss del banner de pausa (solo sessionStorage, CAPDT-320). */

export const HIRING_PAUSE_BANNER_DISMISS_SESSION_KEY = 'hiring_pause_banner_dismissed';

export function isHiringPauseBannerDismissed(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(HIRING_PAUSE_BANNER_DISMISS_SESSION_KEY) === '1';
}

export function dismissHiringPauseBanner(): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(HIRING_PAUSE_BANNER_DISMISS_SESSION_KEY, '1');
}

export function clearHiringPauseBannerDismissForTests(): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(HIRING_PAUSE_BANNER_DISMISS_SESSION_KEY);
}
